import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '../../../../../../../node_modules/@angular/forms';
import {UtilConfig} from '../../../../../autenticacion/servicios/UtilConfig';
import swal from 'sweetalert2';
import {ActivatedRoute, Router} from '../../../../../../../node_modules/@angular/router';
import {ConsumerService} from '../../../../recursos/servicio/consumer.service';
import {WebServices} from '../../../../recursos/modelo/consumerModel/web-services.enum';
import {SecurityConfigService} from '../../../../../autenticacion/servicios/security-config.service';
import {Configuracion} from '../recursos/configuracion';

@Component({
    selector: 'app-name',
    templateUrl: './views/form-configuracion.component.html',
    styleUrls: ['./css/form-configuracion.component.scss'],
    providers: [ConsumerService, SecurityConfigService]
})
export class FormConfiguracionComponent implements OnInit {
    accion = "";
    loading = false;
    usuarioSession: any;
    configuration = new Configuracion();
    form: FormGroup;

    vld_numInt: FormControl;
    vld_numClavesAnt: FormControl;
    vld_diasExpiracion: FormControl;
    vld_formatoClave: FormControl;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_CONFIGURATION_SECURITY_REGISTRAR: false,
        ROLE_CONFIGURATION_SECURITY_CONSULTAR: false,
        ROLE_CONFIGURATION_SECURITY_MODIFICAR: false,
    };

    constructor(private fb: FormBuilder, private jwtUtil: UtilConfig, private route: ActivatedRoute,
                private consumer: ConsumerService, private router: Router, private securityConfig: SecurityConfigService) {
        this.createFormControls();
        this.createForm();
        // VERIFICA LOS PERMISOS DEL ROL LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);
        this.usuarioSession = jwtUtil.getCurrentUser();
    }

    ngOnInit(): void {
        //console.log(this.usuarioSession);
        this.securityConfig.obtenerConfiguracion(this.usuarioSession.username, this.usuarioSession.customer.ruc, this.usuarioSession.customer.id).subscribe(config => {
            let conf = JSON.parse(config._body);
            if (conf.codigo === 1) {
                this.accion = "Modificar";
                this.configuration = conf.configurationSecurity;
            } else {
                this.accion = "Crear";
            }
        });

    }

    createFormControls() {
        this.vld_numInt = new FormControl({value: ""}, Validators.required);
        this.vld_numClavesAnt = new FormControl({value: ""}, Validators.required);
        this.vld_diasExpiracion = new FormControl({value: ""}, Validators.required);
        this.vld_formatoClave = new FormControl({value: ""}, Validators.required);
    }


    createForm() {
        this.form = this.fb.group({
            "vld_numInt": this.vld_numInt,
            "vld_numClavesAnt": this.vld_numClavesAnt,
            "vld_diasExpiracion": this.vld_diasExpiracion,
            "vld_formatoClave": this.vld_formatoClave
        });
    }

    deshabilitarBoton(): boolean {
        return !this.form.valid;
    }

    AutorizarActualizacion() {
        swal({
            title: '¿Está seguro que desea ' + this.accion + ' la configuración? ',
            text: "",
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, ' + this.accion + '!'
        }).then(() => {
            this.actualizar();
        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
            }
        })
    }

    actualizar() {
        this.loading = true;
        let requestParam: any;
        if (this.accion === 'Modificar') {
            requestParam = {
                configurationSecurity: {
                    id: this.configuration.id,
                    passwordRegex: this.vld_formatoClave.value,
                    numberAttempts: this.vld_numInt.value,
                    passwordExpirationDays: this.vld_diasExpiracion.value,
                    numberPasswordRemember: this.vld_numClavesAnt.value,
                    logEstatusRegistro: this.configuration.logEstatusRegistro,
                    customer: {id: this.usuarioSession.customer.id}
                },
                customer: {id: this.usuarioSession.customer.id}
            };
        } else {
            requestParam = {
                configurationSecurity: {
                    passwordRegex: this.vld_formatoClave.value,
                    numberAttempts: this.vld_numInt.value,
                    passwordExpirationDays: this.vld_diasExpiracion.value,
                    numberPasswordRemember: this.vld_numClavesAnt.value,
                    logEstatusRegistro: this.configuration.logEstatusRegistro,
                    customer: {id: this.usuarioSession.customer.id}
                },
                customer: {id: this.usuarioSession.customer.id}
            };
        }


        this.consumer.create(WebServices.URL_ACTUALIZAR_CONFIGURACION, requestParam)
            .subscribe(result => {
                swal(
                    'Actualizado!',
                    'Se ha ' + this.accion + ' la configuración!',
                    'success'
                );
                this.loading = false;
            }, err => {
                this.loading = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo " + this.accion + " la configuracion", this.router)
            });
    }

    backClicked() {
        this.router.navigate(['/content', {outlets: {'second': ['home']}}]);
    }

    toggleEstado() {
        if (this.configuration.logEstatusRegistro == 'ACTIVO') {
            this.configuration.logEstatusRegistro = 'INACTIVO';
        } else {
            this.configuration.logEstatusRegistro = 'ACTIVO';
        }
    }
}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/configuracion/cmp-form-configuracion/form-configuracion.component.ts